import React, { useMemo } from 'react';

const DemandPressurePanel = ({ items = [] }) => {
  const ranked = useMemo(
    () => [...items].sort((a, b) => Number(b?.demandPressureScore || 0) - Number(a?.demandPressureScore || 0)).slice(0, 6),
    [items],
  );

  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/80 p-4">
      <h3 className="text-sm font-semibold text-slate-100">Tekanan Permintaan</h3>
      <div className="mt-3 space-y-2">
        {ranked.length === 0 ? <p className="text-xs text-slate-500">Belum ada data.</p> : ranked.map((row) => (
          <div key={row.candidateId} className="flex items-center justify-between rounded-md border border-slate-800 bg-slate-950/70 px-3 py-2 text-xs">
            <span className="text-slate-300">{row.areaName || row.scopeKey}</span>
            <span className="font-semibold text-sky-300">{Number(row.demandPressureScore || 0).toFixed(1)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DemandPressurePanel;
